import React from "react"
import SEO from "../components/seo"
import Layout from '../containers/layout/layout'
import Header from '../containers/layout/header/header-five'
import Footer from '../containers/layout/footer/footer-one'
import PageHeader from '../containers/about-us/page-header'
import AboutArea from '../containers/about-us/about-area'
import SolutionsArea from '../containers/about-us/solutions-area'
import TestimonialArea from '../containers/elements/testimonials/section-two'
import ClientsArea from '../containers/elements/client-logo/section-one'
import ContactArea from '../containers/global/contact-area/contact-two'
import ContactFormArea from '../containers/index-cybersecurity/contact-form-area'
import ResourcesArea from '../containers/about-us/resources-area'

const AboutPage = ({ location }) => (
  <Layout location={location}>
    <SEO title="About Us" />
    <Header />
    <main className="site-wrapper-reveal">
      <PageHeader />
      <AboutArea />
      <ResourcesArea />
      <SolutionsArea />
      <TestimonialArea />
      <ClientsArea />
      <ContactArea />
      <ContactFormArea />
    </main>
    <Footer />
  </Layout>
)

export default AboutPage
